import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'thumbnailImageUrl'
})
export class ThumbnailImageUrlPipe implements PipeTransform {

    transform(value?: any): string {
        if(value){
            const fullSizeImageUrl = value;
            const thumbnailImageUrl = fullSizeImageUrl.replace(".jpg", "_dt.jpg");
            return thumbnailImageUrl;
        }
        return ;
    }

}


// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/pipes-v1/thumbnail_image_url.pipe.ts